/* projects/wtaf/src/app/features/widgets/all-execution-report-widget/all-execution-report-widget.component.css */
.widget-subtitle {
  font-size: 12px;
  color: #6c757d;
}
.counter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.counter-pill {
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  padding: 5px 8px;
  border-radius: 999px;
  border: 1px solid transparent;
}
.counter-total {
  background: #f1f3f5;
  border-color: #d9dee3;
  color: #495057;
}
.counter-running {
  background: #eaf4ff;
  border-color: #a5cffd;
  color: #1f78d1;
}
.counter-completed {
  background: #eaf8f0;
  border-color: #b9e7ca;
  color: #1aaa55;
}
.counter-incomplete {
  background: #fff2e8;
  border-color: #f8cfaf;
  color: #d96b1d;
}
.counter-terminated {
  background: #fff4e6;
  border-color: #ffd59e;
  color: #d9822b;
}
.counter-skipped {
  background: #f2f0ff;
  border-color: #cdc7ff;
  color: #5b54c7;
}
.filter-label {
  font-size: 12px;
  font-weight: 600;
  color: #343a40;
  margin-bottom: 4px;
}
.error-msg {
  color: #db3b21;
  font-size: 13px;
  font-weight: 500;
}
.no-record {
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  padding: 10px;
}
.pass-text {
  color: #1aaa55;
  font-weight: 600;
}
.fail-text {
  color: #db3b21;
  font-weight: 600;
}
.skip-text {
  color: #5b54c7;
  font-weight: 600;
}
.status-running {
  color: #1f78d1;
  font-weight: 600;
}
.status-completed {
  color: #1aaa55;
  font-weight: 600;
}
.status-incomplete {
  color: #f2994a;
  font-weight: 600;
}
.status-terminated {
  color: #d9822b;
  font-weight: 600;
}
.status-unknown {
  color: #6c757d;
  font-weight: 600;
}
.see-more-link {
  font-size: 14px;
  color: #007bff;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
.user-filter-dropdown {
  position: relative;
}
.user-filter-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.user-filter-caret {
  font-size: 10px;
  color: #6c757d;
}
.user-filter-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 10;
  background: #fff;
  border: 1px solid #d9dee3;
  border-radius: 4px;
  padding: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}
.user-filter-actions {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eef1f4;
  padding-bottom: 6px;
  margin-bottom: 6px;
}
.user-filter-list {
  max-height: 180px;
  overflow-y: auto;
}
.user-filter-option {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  padding: 3px 0;
  font-size: 12px;
  color: #343a40;
}
.user-filter-empty {
  font-size: 12px;
  color: #6c757d;
}
/*# sourceMappingURL=all-execution-report-widget.component.css.map */
